import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'mobx-react';
import AppFrame from './views/AppFrame/AppFrame';
import './App.css';

import stores from './stores/';
import ScrollToTop from './views/AppFrame/ScrollTop';
function App() {
  return (
    <div className="my-mui-app">
      <Provider {...stores}>
        <Router basename={'/equimanage'}>
          <ScrollToTop />
          <AppFrame />
        </Router>
      </Provider>
    </div>

  );
}

export default App;
